<template>
  <el-pagination
    class="le-paging"
    :background="tableParams.background"
    :current-page="tableParams.tablePageNum"
    :page-size="tableParams.tablePageSize"
    :page-sizes="tableParams.tablePageSizes"
    :total="tableParams.tableTotalCount"
    :layout="tableParams.tablePagingLayout"
    :hide-on-single-page="tableParams.hideOnSinglePage"
    @size-change="sizeChangeEvent"
    @current-change="loadDataEvent" />
</template>

<script>
export default {
  name: 'LePaging',
  props: {
    tableParams: {
      type: Object,
      default() {
        return {
          background: true,
          tablePageNum: 1,
          tablePageSize: 20,
          tablePageSizes: 0,
          tableTotalCount: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
          tablePagingLayout: 'prev, pager, next, total, sizes, jumper',
          hideOnSinglePage: true
        };
      },
      required: true
    },
    sizeChangeEvent: {
      type: Function,
      required: true
    },
    loadDataEvent: {
      type: Function,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../static/styles/le_paging";
</style>
